module.exports = __webpack_public_path__ + "img/countries-icons-phone-number.22c59cd1.svg";